module.exports = __webpack_public_path__ + "media/images/pages/peel-case/case-1-83262d893b5fde23f1bebd9d93f35b3a.png";